import React from "react";
import { observer } from "mobx-react";
import {
  Switch as SwitchContext,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";

import AuthStore from "stores/AuthStore";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import Workouts from "./Workouts";
import WorkoutDetails from "./Workouts/WorkoutDetails";
import Movements from "./Movements";
import Equipment from "./Equipment";

import { PrivateRoute } from "navigation/Switch";

import ROUTES from "navigation/routes";

type Props = RouteComponentProps & {};

@observer
class ContentStudio extends React.Component<Props> {
  onPublishAllContent = () => {};

  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <SwitchContext>
          <PrivateRoute
            path={ROUTES.CONTENT_STUDIO_WORKOUTS}
            component={Workouts}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_STUDIO_WORKOUTS}
            exact
          />
          <PrivateRoute
            path={[ROUTES.CONTENT_STUDIO_WORKOUT_DETAILS]}
            component={WorkoutDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_STUDIO_WORKOUTS}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_STUDIO_MOVEMENTS}
            component={Movements}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_STUDIO_WORKOUTS}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_STUDIO_EQUIPMENT}
            component={Equipment}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_STUDIO_WORKOUTS}
            exact
          />

          <Redirect to={ROUTES.CONTENT_STUDIO_WORKOUTS} />
        </SwitchContext>
      </Container>
    );
  }
}

export default withRouter(ContentStudio);
